import styled from 'styled-components'

export const LookupAccountPageWrapper = styled.div`
  margin-top: 32px;
  padding: 0 16px;
  @media only screen and (max-width: 768px) {
    margin-top: 0;
  }
`

